export default {"src":"/_next/static/media/schermen.10a3e7b9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};